import React from "react";
import ResizePanel from "../../modules/react-resize-panel.new/src/ResizePanel";
// import ResizePanel from "react-resize-panel";

import { AutoResizeDiv } from "./AutoResizeDiv";
import styles from "./ResizeLayout.module.css";

export const VerticalResizeDiv = ({
  width,
  height,
  children,
  bottomHeight,
}: {
  width?: number;
  height?: number;
  children: any;
  bottomHeight?: number;
}) => {
  if (React.Children.count(children) !== 2)
    throw new Error(
      `VerticalResizeDiv expect exactly two (top & bottom) children (got ${React.Children.count(children)}).`
    );

  const [top, bottom] = children;

  // console.log("vertical dim", width, height, "->", bottomHeight ? bottomHeight : height ? height / 2 : 100);
  // console.log("vertical", height, width);
  // if (!height || height < 2) return null;
  if (width === undefined || height === undefined || width < 2 || height < 2) return <></>;

  return (
    <div className={styles.vertical} style={{ width: width || 0, height: height || 0 }}>
      <div className={styles.content}>
        <AutoResizeDiv>{top}</AutoResizeDiv>
      </div>
      <ResizePanel
        direction="n"
        style={{ height: bottomHeight ? bottomHeight : height ? height / 2 : 100, minHeight: 1 }}
        // handleClass={styles.horizontalHandle}
        handleClass={"horizontalHandle"}
        borderClass={"horizontalResizeBorder"}
      >
        <AutoResizeDiv className={styles.content}>{bottom}</AutoResizeDiv>
      </ResizePanel>
    </div>
  );
};
